import { css } from 'styled-components'

import { Colours } from '@lib/theme'

export const CSSBase = css`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: center;

  margin: 0;
  padding: 0.25rem 0.4rem;
  border-radius: 5px;

  border-style: solid;
  border-width: 1.5px;
  border-color: ${Colours.FgShade.Mid};

  line-height: 1;
  font-weight: 700;
  text-decoration: none;

  background-color: transparent;
  color: ${Colours.FgShade.Mid};

  :hover {
    background-color: white;
    color: ${Colours.FgShade.Mid};
    filter: brightness(1.1);
  }
  :active {
    background-color: white;
    color: ${Colours.FgShade.Mid};
    filter: brightness(0.9);
  }

  :disabled {
    opacity: 0.4;
    :hover {
      filter: brightness(1);
    }
  }

  > div {
    display: flex;
    flex: 1 1 auto;
  }

  > svg {
    display: flex;
    flex: 0 0 auto;
  }

  > * {
    margin-right: 0.25rem;
  }
  > :last-child {
    margin-right: 0;
  }
`
